import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stackFilter'
})
export class StackFilterPipe implements PipeTransform {

  transform(arr: any, stackPosition: string, stack: number): any {
    let transformedList = arr;
    let searchKey = stackPosition.toLowerCase();
    if (searchKey && stack > 1) {
      transformedList = transformedList.filter((element: any) => {
        if (searchKey === 'lower') {
          if (element?.stackPosition !== 2) {
            return element;
          }
        } else {
          if (element?.stackPosition === 2) {
            return element;
          }
        }
      });
    }
    return transformedList;
  }

}
